
import { useNavigate } from 'react-router-dom';

export default function ChildcareBanner() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/childcare');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const plans = [
    { label: 'ハーフデイ', duration: '〜4時間', price: '¥3,500', unit: '/回' },
    { label: 'フルデイ', duration: '〜8時間', price: '¥6,000', unit: '/回' },
    { label: 'ナイト', duration: '夜間対応', price: '¥8,000', unit: '/回' },
  ];

  return (
    <section
      className="relative py-0"
      style={{
        background: 'linear-gradient(135deg, #fdf0f5 0%, #fce4ee 50%, #fdf0f5 100%)',
        fontFamily: "'Noto Serif JP', serif",
      }}
    >
      {/* 上部装飾ライン */}
      <div className="w-full h-1 flex overflow-hidden">
        {Array.from({ length: 80 }).map((_, i) => (
          <div
            key={i}
            className="flex-1 h-1"
            style={{ backgroundColor: i % 2 === 0 ? '#c0506a' : '#f0a0b8' }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-4">

          {/* 左：アイコン＋テキスト */}
          <div className="flex items-center gap-4 flex-shrink-0">
            <div className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0"
              style={{ backgroundColor: '#fce4ee' }}>
              <i className="ri-parent-line text-2xl" style={{ color: '#c0506a' }}></i>
            </div>
            <div>
              <div className="flex items-center gap-2 mb-0.5">
                <p className="text-xs" style={{ color: '#a0405a', letterSpacing: '0.1em' }}>
                  NEW SERVICE
                </p>
                <span
                  className="text-xs font-bold px-2 py-0.5 rounded-full"
                  style={{ backgroundColor: '#c0506a', color: '#fff' }}
                >
                  初回 ¥500 OFF
                </span>
              </div>
              <p className="text-sm font-semibold" style={{ color: '#7a2040' }}>
                お子様のお預かりサービスを始めました
              </p>
              <p className="text-xs mt-0.5" style={{ color: '#a0607a' }}>
                保育士常駐・安心の環境でお子様をお預かりします
              </p>
            </div>
          </div>

          {/* 中央：料金プラン */}
          <div className="flex items-center gap-2">
            {plans.map((plan, i) => (
              <div key={i} className="flex flex-col items-center px-4 py-2 rounded-xl"
                style={{ backgroundColor: 'rgba(255,255,255,0.7)', border: '1px solid #f0c0d0' }}>
                <span className="text-xs font-semibold mb-0.5" style={{ color: '#c0506a' }}>
                  {plan.label}
                </span>
                <span className="text-xs" style={{ color: '#a0607a' }}>
                  {plan.duration}
                </span>
                <div className="flex items-baseline gap-0.5 mt-1">
                  <span className="text-base font-bold" style={{ color: '#7a2040' }}>
                    {plan.price}
                  </span>
                  <span className="text-xs" style={{ color: '#a0607a' }}>
                    {plan.unit}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* 右：ボタン */}
          <button
            onClick={handleClick}
            className="group inline-flex items-center gap-2 text-sm whitespace-nowrap px-5 py-2.5 rounded-full transition-all duration-300 cursor-pointer hover:gap-3 flex-shrink-0"
            style={{
              backgroundColor: '#c0506a',
              color: '#fff',
            }}
          >
            <span>詳しく見る・予約する</span>
            <i className="ri-arrow-right-line text-base transition-transform duration-300 group-hover:translate-x-1"></i>
          </button>
        </div>
      </div>

      {/* 下部装飾ライン */}
      <div className="w-full h-1 flex overflow-hidden">
        {Array.from({ length: 80 }).map((_, i) => (
          <div
            key={i}
            className="flex-1 h-1"
            style={{ backgroundColor: i % 2 === 0 ? '#f0a0b8' : '#c0506a' }}
          />
        ))}
      </div>
    </section>
  );
}
